<template>
  <v-card class="ad px-2 py-2" style="box-shadow: none; background-color: transparent !important;">
    <v-card-title v-if="hasAd" class="justify-end mt-n7 mb-n4">
      <div class="badge">AD</div>
    </v-card-title>
    <v-card-text class="d-flex align-center justify-center">
      <v-avatar v-if="$store.state.user.imageUrl !== null" size="63"
                :class="`${(isEmbedded)? '' : 'clickable-avatar'} mr-5`" @click="goToProfile">
        <v-img :src="$store.state.user.imageUrl"/>
      </v-avatar>
      <div>
        <h3>{{ $t('greetings.hi') }},</h3>
        <h1>{{ $store.state.user.firstName }}</h1>
      </div>
      <v-spacer/>
      <div v-if="$store.state.user.isPro">
        <div class="d-flex align-center justify-start">
          <p class="my-0 mr-1" v-html="$t('pro.title')"/>
          <ProBadge size="small"/>
        </div>
        <div v-if="isEmbedded" class="d-flex align-center justify-start">
          <p class="my-0 mt-2" v-html="$t('pro.byWhitelabel')"/>
          <v-img max-width="112" :src="partnerLogo"/>
        </div>
      </div>
      <div v-else-if="hasAd">
        <h4 v-if="ad.title !== null">{{ ad.title }}</h4>
        <v-btn v-if="ad.btnText !== null" @click="openUrl" class="ad-btn mt-1" small>{{ ad.btnText }}</v-btn>
      </div>
      <p v-else class="my-0" v-html="$t('message_UserWelcome')"/>
    </v-card-text>
  </v-card>
</template>

<script>
import EmbedEngine from "@/views/Embed/embedEngine";
import AdEngine from '../../../ads/adEngine';
import ProBadge from "@/components/ProBadge.vue";
import { getFullLogo } from '@/utils/partnerLogos';
export default {
  name: "UserWelcome",
  components: {ProBadge},
  data() {
    return {
      // Ads
      hasAd: false,
      ad: null,
    };
  },
  watch: {
    '$store.state.user.isPro': function () {
      this.retrieveAd();
    },
    '$store.state.ads': function () {
      this.retrieveAd();
    },
  },
  computed: {
    isEmbedded() {
      return EmbedEngine.isEmbeddedSwiset();
    },
    partnerLogo() {
      return getFullLogo(this.$store.state.whitelabel.partner);
    }
  },
  mounted() {
    this.retrieveAd();
  },
  methods: {
    retrieveAd() {
      this.ad = AdEngine.getRandomAd('Small Ad');
      this.hasAd = this.ad !== null && this.ad !== undefined;
    },
    openUrl() {
      window.open(this.ad.ctaUrl);
    },
    goToProfile() {
      if(!this.isEmbedded)
        this.$router.push('/profile');
    }
  },
}
</script>

<style lang="scss" scoped>
@import "src/global";

.ad {
  .badge {
    font-size: 12px;
    color: $white-color;
    background-color: $blue-color;
    margin-right: -5px;
    padding: 3px 5px 6px;
    border-bottom-right-radius: 14px;
    border-bottom-left-radius: 14px;
  }
}

.ad-btn {
  color: $calm-green !important;
  background-color: $dark-green !important;
  border: none !important;
}

.ad-btn:hover {
  border: none !important;
}

.clickable-avatar {
  cursor: pointer;
}
</style>

